import React from 'react';
import Logo from './img/logo-white.svg';

function Navbar() {
    return (
        <div className="navbar">
            <div className="navbar-brand">
                <img src={Logo}/>
            </div>
            <div className="navbar-links">
                <div className="navbar-link">
                    <p>ABOUT</p>
                </div>
                <div className="navbar-link">
                <p>JOBS</p>
                </div>
                <div className="navbar-link">
                    <p>SERVICES</p>
                </div>
            </div>
        </div>
    )
}

export default Navbar;
